module.exports = __webpack_public_path__ + "img/logo-v.11817f8c.png";